import { useState, useEffect } from "react";
import { Document, Page } from "react-pdf";

// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//   "pdfjs-dist/build/pdf.worker.min.mjs",
//   import.meta.url
// ).toString();

export const ShowPDF = ({ screenshotImageDimensions, screenshotImage }) => {
  const [myblob, setMyblob] = useState(null);

  useEffect(() => {
    function getBlob(url) {
      return fetch(url).then((res) => res.blob());
    }
    getBlob(screenshotImage.image).then((blob) => {
      setMyblob(blob);
    });
  }, [screenshotImage]);

  const onDocumentLoadSuccess = () => {
    console.log("success");
    window.open(screenshotImage.image, "_blank");
  };

  return myblob ? (
    <Document file={myblob} onLoadSuccess={onDocumentLoadSuccess}>
      <Page pageNumber={2} />
    </Document>
  ) : null;
};
